import React, { useEffect } from "react";
import TrackerTable from "./components/TrackerTable";
import { useAsanaData } from "../../contexts/AsanaContext";
import { useDealData } from "../../contexts/DealContext";

const DealTracker = () => {
    // Use the AsanaContext instead of local state
    const {
        loading,
        error,
        dealsBySection,
        filteredSections,
        expandedSections,
        toggleSection,
        StatusBadge,
        asanaDeals
    } = useAsanaData();

    const { consolidatedData, currentDealName } = useDealData();

    // Debug logging
    useEffect(() => {
        if (asanaDeals.length > 0 && consolidatedData) {
            console.log("Available Asana deals:", asanaDeals.map(deal => deal.name));

            // Get all deal names from the consolidatedData
            const appDealNames = Object.keys(consolidatedData);
            console.log("Available deal names in app:", appDealNames);

            // Check if current deal has a match in Asana
            if (currentDealName) {
                console.log("Currently selected deal:", currentDealName);
                const matchingAsanaDeal = asanaDeals.find(deal =>
                    deal.name.toLowerCase().includes(currentDealName.toLowerCase()) ||
                    deal.name.toLowerCase().replace(/🔥|(\u{1F525})/gu, '').trim() === currentDealName.toLowerCase()
                );
                console.log("Matching Asana deal:", matchingAsanaDeal ? matchingAsanaDeal.name : "None found");
            }
        }
    }, [asanaDeals, consolidatedData, currentDealName]);

    return (
        <TrackerTable
            loading={loading}
            error={error}
            deals={dealsBySection}
            sections={filteredSections}
            expandedSections={expandedSections}
            toggleSection={toggleSection}
            StatusBadge={StatusBadge}
        />
    );
};

export default DealTracker;